import * as React from "react";
import get from "lodash/get";

import "./PointsHistory.css";
import { onClickSendToMerchant } from "../../utils/sendClickToMerchant";
import { WidgetProps } from "../Widget/Widget";
import { getHorizontalAlignment } from "../../utils/getHorizontalAlignment";
import { formatUserFacingNumber } from "../../utils/number";

export interface PointsHistoryProps extends WidgetProps {
  classNames: string;
  name: string;
  configName: string;
  style?: React.CSSProperties;
  descriptionStyle?: React.CSSProperties;
  pointsStyle?: React.CSSProperties;
  dividerStyle?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
  align?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
}

export class PointsHistory extends React.Component<PointsHistoryProps> {
  component: HTMLDivElement | null;

  componentDidMount() {
    if (this.component && this.props.horizontalAlign) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  componentDidUpdate(prevProps: PointsHistoryProps) {
    if (
      this.component &&
      prevProps.horizontalAlign !== this.props.horizontalAlign
    ) {
      this.component.style.left = getHorizontalAlignment(
        window.document.body.clientWidth,
        this.component.getBoundingClientRect(),
        this.props.horizontalAlign,
        this.props.config
      );
    }
  }

  render() {
    const {
      classNames,
      configName,
      descriptionStyle,
      pointsStyle,
      dividerStyle,
      style,
    } = this.props;

    return (
      <div
        id={this.props.configName}
        onClick={onClickSendToMerchant(configName)}
        className={`PointsHistory-container ${classNames || ""}`}
        style={{ ...style, maxHeight: get(style, "height", "inherit") }}
        aria-label="Points History"
        ref={(component) => (this.component = component)}
      >
        {exampleActivities.map((activity, index) => {
          return (
            <React.Fragment key={`${activity.activity}-${index}`}>
              <div className="PointsHistory-item" key={activity.activity}>
                <div tabIndex={0} style={descriptionStyle}>
                  {activity.description}
                </div>
                <div tabIndex={0} style={pointsStyle}>
                  +{formatUserFacingNumber(Number(activity.points))}
                </div>
              </div>
              <div className="PointsHistory-divider" style={dividerStyle} />
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

const exampleActivities = [
  {
    activity: "purchase",
    description: "Purchase",
    icon: "purchase",
    points: "124",
    status: "completed",
  },
  {
    activity: "facebook_like",
    description: "Like us on Facebook",
    icon: "facebookLike",
    points: "10",
    status: "completed",
  },
  {
    activity: "facebook_share",
    description: "Share us on Facebook",
    icon: "facebookShare",
    points: "20",
    status: "pending",
  },
  {
    activity: "purchase",
    description: "Purchase",
    icon: "purchase",
    points: "86",
    status: "completed",
  },
  {
    activity: "purchase",
    description: "Purchase",
    icon: "purchase",
    points: "28",
    status: "completed",
  },
];
